// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"378":"15812be8","782":"7b263e37","970":"c4adde04"}[chunkId] + ".css";
};